function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M32.467 8.369a1.406 1.406 0 112.24 1.7L18.31 31.685a1.406 1.406 0 01-2.045.21L5.48 22.476a1.406 1.406 0 011.85-2.118l9.649 8.426L32.467 8.369z",
  id: "tick-o_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#tick-o_svg__a",
  transform: "translate(-5 -7)"
});

var SvgTickO = function SvgTickO(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 26
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzBweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMzAgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjMgKDY3Mjk3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5JY29uL1RpY2stbzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxwYXRoIGQ9Ik0zMi40NjcxMDQyLDguMzY4ODU1NDEgQzMyLjkzNjQ4OCw3Ljc1MDA5NDc4IDMzLjgxODYwMzQsNy42MjkwMDA5NSAzNC40MzczNjQsOC4wOTgzODQ3NyBDMzUuMDU2MTI0Niw4LjU2Nzc2ODU5IDM1LjE3NzIxODQsOS40NDk4ODM5NiAzNC43MDc4MzQ2LDEwLjA2ODY0NDYgTDE4LjMxMDAwOCwzMS42ODQ5MTkyIEMxNy44MTc1ODk3LDMyLjMzNDA0NDggMTYuODc4MzE5MiwzMi40MzAxNTk5IDE2LjI2NDYzMzksMzEuODk0MjIxNCBMNS40ODEyNDEyMiwyMi40NzY5NiBDNC44OTYyNjI5OSwyMS45NjYwOTE3IDQuODM2MTg0OTgsMjEuMDc3NzMyNiA1LjM0NzA1MzIyLDIwLjQ5Mjc1NDQgQzUuODU3OTIxNDcsMTkuOTA3Nzc2MiA2Ljc0NjI4MDU2LDE5Ljg0NzY5ODIgNy4zMzEyNTg3OCwyMC4zNTg1NjY0IEwxNi45Nzk4NDI4LDI4Ljc4NDc4NjMgTDMyLjQ2NzEwNDIsOC4zNjg4NTU0MSBaIiBpZD0icGF0aC10aWNrLW8iPjwvcGF0aD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSItIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzkxLjAwMDAwMCwgLTE4Mi4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Ikljb24vVGljay1vIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzODYuMDAwMDAwLCAxNzUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8bWFzayBpZD0ibWFzay0yIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC10aWNrLW8iPjwvdXNlPgogICAgICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICAgICAgPHVzZSBpZD0iUGF0aC01NiIgZmlsbD0iIzAwMDAwMCIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjcGF0aC10aWNrLW8iPjwvdXNlPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgTickO as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./src/components/lib/Icons/SystemIcon/svg/tick-o.svg
// module id = 905
// module chunks = 0